<template>
  <v-container class="container-feedback px-5 pt-5 pb-0">
    <v-row no-gutters justify="center" align="center" style="">
      <v-col cols="12" align-self="center" class="content-title mb-3">
        <span>
          <span style="color: #ddd; font-weight: 400">
            {{ 'Let' }}
          </span>
          <span>
            {{
              currentClip.clipUploader.userDisplayName
                ? currentClip.clipUploader.userDisplayName
                : currentClip.clipUploader.userFullName
            }}
          </span>
          <span style="color: #ddd; font-weight: 400">{{ 'know what you think' }}</span>
        </span>
      </v-col>
      <v-col cols="12" align-self="center" class="content-text">
        <v-btn-toggle v-model="toggledEmoji" background-color="transparent" multiple>
          <v-btn class="btn-emoji-feedback" dark value="U+2705" @click="clickEmoji(0)" :disabled="this.isLoading" plain>
            <fluent-emoji-check-mark-button size="2rem"></fluent-emoji-check-mark-button>
          </v-btn>
          <v-btn
            class="btn-emoji-feedback"
            dark
            value="U+1F44F"
            @click="clickEmoji(1)"
            :disabled="this.isLoading"
            plain
          >
            <fluent-emoji-clapping-hands size="2rem"></fluent-emoji-clapping-hands>
          </v-btn>
          <v-btn class="btn-emoji-feedback" dark value="U+2764" @click="clickEmoji(2)" :disabled="this.isLoading" plain>
            <fluent-emoji-red-heart size="2rem"></fluent-emoji-red-heart>
          </v-btn>
          <v-btn
            class="btn-emoji-feedback"
            dark
            value="U+1F440"
            @click="clickEmoji(3)"
            :disabled="this.isLoading"
            plain
          >
            <fluent-emoji-eyes size="2rem"></fluent-emoji-eyes>
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row no-gutters justify="space-between" align="center" dense>
      <v-col cols="auto">
        <v-btn
          plain
          @click.stop="cancelFeedback()"
          color="rgb(20, 35, 42)"
          elevation="0"
          :height="isMobile ? 30 : 45"
          dark
          :class="$vuetify.breakpoint.width < 960 ? 'btn-move-mobile' : 'btn-move'"
        >
          <span
            :class="
              $vuetify.breakpoint.width < 960
                ? 'material-icons-round btn-close-icon-mobile'
                : 'material-icons-round btn-close-icon '
            "
            translate="no"
          >
            close
          </span>
          <span class="ml-1 btn-move-text">Dismiss</span>
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn
          plain
          @click.stop="nextClip()"
          color="rgb(20, 35, 42)"
          elevation="0"
          :height="isMobile ? 30 : 45"
          dark
          :class="$vuetify.breakpoint.width < 960 ? 'btn-move-mobile' : 'btn-move'"
        >
          <span class="ml-2 btn-move-text">Next</span>
          <span
            :class="
              $vuetify.breakpoint.width < 960
                ? 'material-icons-round btn-move-icon-mobile'
                : 'material-icons-round btn-move-icon '
            "
            translate="no"
          >
            chevron_right
          </span>
        </v-btn>
      </v-col>
    </v-row>
    <guest-in v-if="guestInVisible" @close="closeGuestIn" :guestInVisible.sync="guestInVisible"></guest-in>
  </v-container>
</template>

<script>
import Toast from '@/views/meeting/component/Toast'
import { setCreateEmoji, setDeleteEmoji } from '@/services/emoji'
import { isMobile } from '@/common/lib/strLib'
import { mapGetters, mapState } from 'vuex'
import GuestIn from '@/views/modal/GuestIn'
import FluentEmojiCheckMarkButton from '@/views/meeting/component/emoji/FluentEmojiCheckMarkButton'
import FluentEmojiClappingHands from '@/views/meeting/component/emoji/FluentEmojiClappingHands'
import FluentEmojiEyes from '@/views/meeting/component/emoji/FluentEmojiEyes'
import FluentEmojiRedHeart from '@/views/meeting/component/emoji/FluentEmojiRedHeart.vue'

export default {
  components: {
    GuestIn,
    FluentEmojiClappingHands,
    FluentEmojiCheckMarkButton,
    FluentEmojiEyes,
    FluentEmojiRedHeart,
  },
  props: ['allEmojiList', 'localFeedbackEmoji'],
  data() {
    return {
      stopped: false,
      toggledEmoji: [],
      countValue: 7,
      countValuePercent: 100,
      guestInVisible: false,
      guestInActionType: '',
      isLoading: false,
      temporaryEmoji: '',
    }
  },
  mounted() {
    // console.error('mounted Feedback.vue')
    // this.countValueProcess = setInterval(this.countValueTimer, 1000)
    this.$emit('setSeeked', 'end')
  },

  // beforeDestroy() {
  //   console.error('beforeDestroy Feedback.vue')
  // },
  methods: {
    autoUpdate() {
      this.toggledEmoji = []
    },
    cancelFeedback() {
      this.$store.dispatch('setIsFeedback', false)
      this.$store.dispatch('changeCurrentClip', {
        clipIndex: this.clipIndex,
        sectionIndex: this.storeSectionIndex,
        currentClip: this.currentClip,
        timeStampSeekTime: this.$store.getters.duration,
      })
      // this.$store.dispatch('beforeClip')
      // this.$store.dispatch('nextClip')
      this.$emit('setSeeked', 'end')
    },
    beforeClip() {
      this.$store.dispatch('beforeClip')
    },
    nextClip() {
      this.$store.dispatch('nextClip')
    },
    countValueTimer() {
      if (this.countValue > 0) {
        this.countValue -= 1
        this.countValuePercent = this.countValue * (100 / 7)
      }
    },
    clearCountValueTimer() {
      clearInterval(this.countValueProcess)
    },
    // 자동재생 멈춤 버튼
    pauseNext() {
      this.stopped = !this.stopped

      if (this.stopped) {
        this.$emit('playpause', 'pause')
        this.clearCountValueTimer()
      } else {
        this.countValueProcess = setInterval(this.countValueTimer, 1000)
      }
    },
    // 이모지 클릭했을 때 서버에 추가/삭제
    clickEmoji(val) {
      if (
        this.chkMtPublic &&
        this.chkMtPublic['isPublic'] &&
        (!this.currentUser.userId || this.currentUser.userId === null)
      ) {
        this.guestInActionType = 'guestEmoji'
        this.guestInVisible = true
        this.temporaryEmoji = val
      } else {
        if (!this.feedbackEmoji[val].value) {
          if (this.serverCommu) return
          this.setCreateEmoji(this.feedbackEmoji[val].unicode, val)
          this.feedbackEmoji[val].count += 1
          this.feedbackEmoji[val].value = true
          this.feedbackEmoji[val].user.unshift({
            id: this.userInfo.userId,
            name: this.userInfo.userDisplayName || this.userInfo.userFullName,
          })
        } else {
          if (this.serverCommu) return
          this.setDeleteEmoji(this.feedbackEmoji[val].id, val)
          this.feedbackEmoji[val].count -= 1
          this.feedbackEmoji[val].value = false
          this.feedbackEmoji[val].user = this.feedbackEmoji[val].user.filter(
            (element) => element.id !== this.userInfo.userId
          )
        }
      }
    },
    closeGuestIn() {
      this.guestInVisible = false
      if (this.currentUser && !isEmptyObject(this.currentUser)) {
        this.clickEmoji(this.temporaryEmoji)
        this.temporaryEmoji = ''
      }
      function isEmptyObject(param) {
        return Object.keys(param).length === 0 && param.constructor === Object
      }
    },

    async setCreateEmoji(unicode, val) {
      this.isLoading = true
      this.$store.dispatch('setServerCommu', true)
      try {
        let response = await setCreateEmoji(this, this.currentClip.clipId, unicode, 'feedback', 0, 0, 0)
        if (response) {
          this.$store.dispatch('setFirebaseLog', {
            eventName: 'create_clip_emoji',
            eventParam: {
              name: 'create_clip_emoji',
            },
          })
          for (let j = 0; j < this.feedbackEmoji.length; j++) {
            if (this.feedbackEmoji[j].unicode == response.unicode) {
              this.feedbackEmoji[j].id = response.emojiId
            }
          }
        }
      } catch (error) {
        // notify(this, 'Error', this.$t('setEmojiError'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('setEmojiError'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        console.log(error)
        this.feedbackEmoji[val].count -= 1
        this.feedbackEmoji[val].value = false
        this.feedbackEmoji[val].user = this.feedbackEmoji[val].user.filter(
          (element) => element.id !== this.userInfo.userId
        )
      } finally {
        this.$store.dispatch('setFeedbackEmoji', this.feedbackEmoji)
        this.isLoading = false
        this.$store.dispatch('setServerCommu', false)
      }
    },
    async setDeleteEmoji(id, val) {
      this.isLoading = true
      this.$store.dispatch('setServerCommu', true)
      try {
        await setDeleteEmoji(this, this.currentClip.clipId, id, 'emoji')

        this.$store.dispatch('setFirebaseLog', {
          eventName: 'delete_clip_emoji',
          eventParam: {
            name: 'delete_clip_emoji',
          },
        })
      } catch (error) {
        // notify(this, 'Error', this.$t('deleteEmojiError'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('deleteEmojiError'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        console.log(error)
        this.feedbackEmoji[val].count += 1
        this.feedbackEmoji[val].value = true
        this.feedbackEmoji[val].user.unshift({
          id: this.userInfo.userId,
          name: this.userInfo.userDisplayName || this.userInfo.userFullName,
        })
      } finally {
        this.$store.dispatch('setFeedbackEmoji', this.feedbackEmoji)
        this.isLoading = false
        this.$store.dispatch('setServerCommu', false)
      }
    },
  },
  computed: {
    mtInfo() {
      return this.$store.getters.currentMt
    },
    content() {
      return this.$store.getters.currentClip.textClip
    },
    currentUser() {
      let user = this.$store.getters.userInfo
      return user && user !== null ? user : {}
    },
    isMobile() {
      return isMobile()
    },
    ...mapGetters(['feedbackEmoji', 'serverCommu', 'chkMtPublic', 'userInfo', 'currentClip']),
    ...mapState({
      currentClip: (state) => {
        return state.clip.currentClip
      },
      storeSectionIndex: (state) => {
        return state.clip.sectionIndex
      },
      clipIndex: (state) => {
        return state.clip.clipIndex
      },
    }),
  },
  watch: {
    currentClip() {
      this.stopped = false
    },
    sectionIndex() {
      this.stopped = false
    },
    // countValue(val) {
    //   if (val == 0) {
    //     this.$emit('playpause', 'play')
    //   }
    // },
    feedbackEmoji: {
      immediate: true,
      deep: true,
      handler() {
        let list = this.feedbackEmoji
        if (list) {
          for (let i = 0; i < list.length; i++) {
            if (list[i].value && this.toggledEmoji.indexOf(list[i].unicode) < 0) {
              this.toggledEmoji.push(list[i].unicode)
            } else if (list[i].value == false && this.toggledEmoji.indexOf(list[i].unicode) > -1) {
              this.toggledEmoji = this.toggledEmoji.filter((element) => element !== list[i].unicode)
            }
          }
        }
      },
    },
    guestInVisible(val) {
      this.$store.dispatch('setIsGuestVisible', val)
    },
  },
}
</script>

<style>
.container-feedback {
  aspect-ratio: 16 / 9 !important;
  background: rgba(14, 21, 25, 0.66);
  justify-content: center;
  width: 360px;
  height: 180px;
  z-index: 200;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
}
.content-title,
.content-text,
.content-avatar,
.content-name {
  font-size: 14px;
  color: #eee;
  font-weight: 600;
  text-align: center;
}
.content-title {
  font-size: 15px;
}
.btn-emoji-feedback {
  opacity: 1 !important;
  width: 60px !important;
  height: 60px !important;
  margin: 5px;
  border-radius: 10px !important;
  background-color: rgba(14, 21, 25, 1);
}
.btn-emoji-feedback:disabled {
  background-color: rgb(20, 35, 42);
  opacity: 1;
}
.v-btn-toggle > .v-btn.v-btn--active {
  /* outline: 1px solid #666 !important; */
  background-color: #289067;
}
.btn-pause:hover {
  color: white;
}
.opacity-zero {
  transition: opacity 0.3s;
  opacity: 0;
  pointer-events: none;
}
.btn-move {
  position: relative;
  /* border: 1px solid rgba(255, 255, 255, 0.1) !important; */
}
.btn-move-mobile {
  position: relative;
  /* border: 1px solid rgba(255, 255, 255, 0.1) !important; */
}
.btn-move-icon {
  color: #ccc;
  font-size: 25px !important;
  font-weight: 400 !important;
}
.btn-move-icon-mobile {
  color: #ccc;
  font-size: 20px !important;
  font-weight: 400 !important;
}
.btn-close-icon {
  color: #ccc;
  font-size: 20px !important;
  font-weight: 400 !important;
}
.btn-close-icon-mobile {
  color: #ccc;
  font-size: 18px !important;
  font-weight: 400 !important;
}
.btn-move-text {
  color: #ccc;
  font-size: 14px;
}
@media (max-width: 1263px) {
  .container-feedback {
    width: 300px;
    height: auto;
  }
  .content-text,
  .content-avatar,
  .content-name {
    font-size: 12px;
  }
  .content-title {
    font-size: 15px;
  }
  .btn-emoji-feedback {
    width: 40px !important;
    height: 45px !important;
  }
}
</style>
